export const getButtonText = (isEditable, isFormOpen) => {
  if (!isEditable) return 'Non-modifiable (OAuth)';
  if (isFormOpen) return 'Annuler';
  return 'Modifier';
};

export const getButtonColor = (isEditable, isFormOpen) => {
  if (!isEditable) return 'text';
  if (isFormOpen) return 'error';
  return 'primary';
};

export const getButtonSx = isEditable => {
  if (!isEditable) {
    return {
      background: 'rgba(0,0,0, 0.15)',
      color: 'black !important'
    };
  }
  return {};
};
